export let API_URL = apiUrl;
export class Utils {
    static downloadText(text, fileName) {
        const file = new Blob(['\uFEFF' + text], { type: 'text/plain' });
        const a = document.createElement("a");
        a.download = fileName;
        a.href = URL.createObjectURL(file);
        a.click();
    }
    static extractText(html) {
        //uses span to avoid things like &nbsp;
        const span = document.createElement('span');
        span.innerHTML = html.replace(/<[^>]+>/g, ' ').replace(/ +/g, ' ');
        return span.innerText.replace(/[\r\n]/g, "");
    }
    ;
    static flatMap(array, map) {
        const result = [];
        for (let a of array)
            result.push(...map(a));
        return result;
    }
    static chooseTranslation(value) {
        if (!value)
            return "";
        if (value[lang])
            return value[lang];
        if (value["00"])
            return value["00"];
        if (value.en)
            return value.en;
        const keys = Object.keys(value);
        if (keys.length > 0)
            return value[keys[0]];
        return "";
    }
    /*

    //newer version
     static async get<T = any>(api: string): Promise<T | null> {
        return fetch(`${API_URL}${api}`, {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        }).then(async response => {
            if (response.status >= 200 && response.status <= 299) {
                return response.json();
            } else {
                throw response;
            }
        });
    }


     */
    static async get(api) {
        const response = await fetch(`${API_URL}${api}`, {
            "method": "GET",
            "headers": {
                "Accept": "application/json"
            }
        }).catch(err => {
            console.error(err);
        });
        if (!response)
            return null;
        return await response.json();
    }
    static urlify(website) {
        if (website == null)
            return "";
        else if (website.startsWith("http://") || website.startsWith("https://"))
            return website;
        else
            return "https://" + website;
    }
    static async postPactData(api, body, onProgress) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${API_URL}${api}`);
            // Set headers
            xhr.setRequestHeader('Accept', 'application/json');
            // Additional headers can be set here if needed
            // Listen for progress events
            xhr.upload.onprogress = function (event) {
                if (event.lengthComputable) {
                    const percentage = (event.loaded / event.total) * 100;
                    onProgress(percentage); // Call the onProgress callback with the current percentage
                }
            };
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(JSON.parse(xhr.responseText));
                }
                else {
                    reject(new Error(xhr.statusText));
                }
            };
            xhr.onerror = function () {
                reject(new Error('Network error'));
            };
            xhr.send(body);
        });
    }
    static async post(api, body) {
        const response = await fetch(`${API_URL}${api}`, {
            method: "POST",
            headers: {
                //'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
                // Include other headers as required
            },
            body,
        }).then(async (response) => {
            if (response.status >= 200 && response.status <= 299) {
                return response.json();
            }
            else {
                let errors;
                try {
                    errors = await response.json();
                }
                catch (e) {
                    errors = null;
                }
                throw { status: response.statusText, message: errors };
            }
        });
        return await response;
    }
    static formValueToFormData(formValue) {
        let formData = new FormData();
        for (let k of Object.keys(formValue))
            Utils.appendToFormData(formData, k, formValue[k]);
        return formData;
    }
    static appendToFormData(fd, name, value) {
        if (typeof value === 'object' && value !== null) {
            if (value instanceof File || value instanceof Blob && 'name' in value) {
                fd.append(name, value, value.name);
            }
            else if (value instanceof Blob) {
                fd.append(name, value);
            }
            else if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i++)
                    Utils.appendToFormData(fd, name + "[" + i + "]", value[i]);
            }
            else {
                for (let innerName of Object.keys(value))
                    Utils.appendToFormData(fd, name + "[" + innerName + "]", value[innerName]);
            }
        }
        else if (value === true || value === false) {
            fd.append(name, value ? "1" : "0");
        }
        else {
            if (value != '') {
                fd.append(name, value);
            }
        }
    }
    static getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2)
            return parts.pop().split(';').shift();
    }
    static formatFileSize(bytes) {
        if (bytes < 1024)
            return bytes + ' bytes';
        else if (bytes < 1048576)
            return (bytes / 1024).toFixed(2) + ' KB';
        else
            return (bytes / 1048576).toFixed(2) + ' MB';
    }
    /* DEBOUNCE HELPER */
    // Debounce function
    static debounce(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }
    static logMessageAndValue(msg, value) {
        console.log(msg, value);
    }
    static flattenObject(obj, parentKey = '', result = []) {
        for (let [key, value] of Object.entries(obj)) {
            // Construct the key string (e.g., 'step1.firstName')
            let newKey = parentKey ? `${parentKey}.${key}` : key;
            if (value && typeof value === 'object' && !Array.isArray(value)) {
                // If the value is a nested object, recurse
                Utils.flattenObject(value, newKey, result);
            }
            else {
                // If the value is not an object, add it to the result array
                result.push({ path: newKey, value });
            }
        }
        return result;
    }
}
